$(document).ready(function(){
$('img[src="https://www.gravatar.com/avatar/d41d8cd98f00b204e9800998ecf8427e"]').attr('alt', 'Toggle button');
$('img[src="https://cdn.shopify.com/s/files/1/2806/9936/t/71/assets/pf-54f090db--zwssmall2x_1200x.png?v=1607365872"]').attr('alt', 'Zero Waste Store logo');

 $("#b_81015031-ea00-4547-bab4-64b60e6a7d73 > ul").append(`<li>
  
    <a href="#" id="accessibilityWidget" class="t4s-footer-link ">Accessibility widget</a>
  </li>
`);
  setTimeout(function(){
       /*  
 $('a.t4s-full-width-link.is--href-replaced').each(function() {
    var $this = $(this);
     console.log($this);
    var href = $this.attr('href');
    if (href) {
      // Extract the product name (last segment after '/products/')
      var match = href.match(/\/products\/([^\/?#]+)/);
      if (match && match[1]) {
        // Replace hyphens with spaces and decode URI
        var productName = decodeURIComponent(match[1].replace(/-/g, ' '));
        // Set the aria-label
        $this.attr('aria-label', productName);
        console.log($this);
      }
    }
  });


    */

     $("span.t4s-badge-item.t4s-badge-new").each(function() {
        var link = $(this);
        var linkText = link.text();
    var spanElement = $('<span>').text(linkText).addClass('bc');
        link.html(spanElement);
    });
     $('a.t4s-full-width-link').each(function() {
    var $this = $(this);
     console.log($this);
    var href = $this.attr('href');
    if (href) {
      // Extract the product name (last segment after '/products/')
      var match = href.match(/\/products\/([^\/?#]+)/);
      if (match && match[1]) {
        // Replace hyphens with spaces and decode URI
        var productName = decodeURIComponent(match[1].replace(/-/g, ' '));
        // Set the aria-label
        $this.attr('aria-label', productName);
      }
    }
  });
    
$("input.t4s-mini-search__input").attr("aria-label", "Enter search term");
        // Quantity minus button
$('button.t4s-quantity-selector.is--minus').attr('aria-label', 'Decrease quantity');

// Quantity plus button
$('button.t4s-quantity-selector.is--plus').attr('aria-label', 'Increase quantity');
    $('input.t4s-quantity-input').attr('aria-label', 'Enter product quantity');
    $("button.t4s-minicart-tabs-item").attr("aria-label", "minicart item");
    
    $("button[type='submit'].t4s-d-none").attr("aria-label", "submit button");
     $("img[src='https://www.gravatar.com/avatar/d41d8cd98f00b204e9800998ecf8427e']").attr("alt", "User avatar placeholder");
$("img[src='https://d3k81ch9hvuctc.cloudfront.net/company/LJYqi3/images/4d43d30c-94d8-47d0-b851-0a65d97267df.jpeg']").attr("alt", "Zero Waste Store promotional image");
$("img[src='https://d3k81ch9hvuctc.cloudfront.net/company/LJYqi3/images/00981e9e-5d9a-4412-bf66-47f74f36791f.png']").attr("alt", "Zero Waste Store logo");
  $("a[href='/collections/zws-bestsellers-collection']").attr("aria-label", "View ZWS Bestsellers Collection");
$("a[href='/collections/zero-waste-kitchen']").attr("aria-label", "View Zero Waste Kitchen Collection");
    $("span.t4s-badge-item.t4s-badge-soldout").each(function() {
        var link = $(this);
        var linkText = link.text();
    var spanElement = $('<span>').text(linkText).addClass('bc');
        link.html(spanElement);
    });

     $('div.t4s-product-inner.t4s-pr.t4s-oh a[href^="/products/travel-tin?"]').attr('aria-label', 'Travel Tin product link');
$('div.t4s-product-inner.t4s-pr.t4s-oh a[href^="/products/conditioner-bar?"]').attr('aria-label', 'Conditioner Bar product link');
$('div.t4s-product-inner.t4s-pr.t4s-oh-oh a[href^="/products/bamboo-soap-dish?"]').attr('aria-label', 'Bamboo Soap Dish product link');
$('div.t4s-product-wrapper.t4s-pr.t4s-oh a[href^="/products/insurance?"]').attr('aria-label', 'Insurance product link');
$('div.t4s-product-wrapper.t4s-pr.t4s-oh a[href^="/products/sunshine-bathroom-bundle-1?"]').attr('aria-label', 'Sunshine Bathroom Bundle product link');
$('div.t4s-product-wrapper.t4s-pr.t4s-oh a[href^="/products/soap-bar?"]').attr('aria-label', 'Soap Bar product link');
$('div.t4s-product-wrapper.t4s-pr.t4s-oh a[href^="/products/badger-organic-shaving-soap?"]').attr('aria-label', 'Badger Organic Shaving Soap product link');
$('div.t4s-product-wrapper.t4s-pr.t4s-oh a[href^="/products/soap-saver-bag?"]').attr('aria-label', 'Soap Saver Bag product link');
$('div.t4s-product-wrapper.t4s-pr.t4s-oh a[href^="/products/zero-waste-shower-bundle?"]').attr('aria-label', 'Zero Waste Shower Bundle product link');
$('div.t4s-product-wrapper.t4s-pr.t4s-oh a[href^="/products/reusable-paper-towels?"]').attr('aria-label', 'Reusable Paper Towels product link');
  },2000)
 $("a[href='/']").attr("aria-label","Navigate to Zero waste store home page");
     $("input.t4s-search__input").attr("aria-label", "Enter search term");
$("input[name='email']").attr("aria-label", "Enter your email");
$('div.pf-accordion-display-content input[type="checkbox"]').attr('aria-label', 'Accordion option');
$('p[data-pf-type="Paragraph4"] input[type="checkbox"][id^="compact"]').attr('aria-label', 'checkbox');

  $("#shopify-section-template--16350918967407__b68da3fe-2de4-41c9-8619-b93b190d85f6 > div > div > div > div > div > a").attr("aria-label","new window");
  $("#shopify-section-template--16350918967407__8471910e-12e1-49f9-8ddb-5b408674dc2e > div > div > div > div > a").attr("aria-label","new window");

$("button[data-breakpoint='mobile']").attr("aria-label", "Toggle mobile view");
$("button[data-breakpoint='tablet']").attr("aria-label", "Toggle tablet view");
$("button[data-breakpoint='desktop']").attr("aria-label", "Toggle desktop view");

$("a[href='/collections/bathroom']").attr("aria-label", "View Bathroom Collection");
$("button.t4s-quantity-selector.is--minus").attr("aria-label", "Decrease quantity");
$("input.t4s-quantity-input").attr("aria-label", "Product quantity");
$("button.t4s-quantity-selector.is--plus").attr("aria-label", "Increase quantity");

 let Intervaltime_task;
let counter_task = 0; 


try {
    Intervaltime_task = setInterval(GenerateAriaLabelFortask, 500);
}
catch (err) {
  
}


function GenerateAriaLabelFortask() {
   
   counter_task++;


   
    if ( $('label.rebuy-checkbox-label').length) {

 $('label.rebuy-checkbox-label').attr('aria-label', 'Rebuy item checkbox');
        clearInterval(Intervaltime_task);
       
    }
    
  
    if (counter_task >= 20) {
        clearInterval(Intervaltime_task);
       
    }
}

 let Intervaltime_google;
let counter_google = 0; 


try {
    Intervaltime_google = setInterval(GenerateAriaLabelForGoogle, 500);
}
catch (err) {
  
}


function GenerateAriaLabelForGoogle() {
   
    counter_google++;

    if ( $('#goog-gt-votingInputSrcLang').length) {
/*
       $('a.t4s-full-width-link').each(function() {
    var $this = $(this);
     console.log($this);
    var href = $this.attr('href');
    if (href) {
      // Extract the product name (last segment after '/products/')
      var match = href.match(/\/products\/([^\/?#]+)/);
      if (match && match[1]) {
        // Replace hyphens with spaces and decode URI
        var productName = decodeURIComponent(match[1].replace(/-/g, ' '));
        // Set the aria-label
        $this.attr('aria-label', productName);
        console.log($this);
      }
    }
  });
      */
      
$("label.adb-switch").append('<span style="display:none">.</span>');

$('#goog-gt-votingInputSrcLang').attr('aria-label', 'Source Language');
  $('#goog-gt-votingInputTrgLang').attr('aria-label', 'Target Language');
  $('#goog-gt-votingInputSrcText').attr('aria-label', 'Source Text');
  $('#goog-gt-votingInputTrgText').attr('aria-label', 'Translated Text');
  $('#goog-gt-votingInputVote').attr('aria-label', 'Vote');
    
        clearInterval(Intervaltime_google);
       
    }
    
  
    if (counter_google >= 30) {
        clearInterval(Intervaltime_google);
       
    }
}

// Tab switcher buttons in the drawer (e.g., cart / wishlist)
$('button.t4s-drawer__tabs-item.t4s-minicart-tabs-item').attr('aria-label', 'Toggle minicart tab');



// Hidden submit button (used for forms, like newsletter)
$('button[type="submit"].t4s-d-none').attr('aria-label', 'Submit form');
// Notify me input field
$('input.notify-me__input').attr('aria-label', 'Enter your email to be notified');

// Quantity input field
$('img[src="//zerowastestore.com/cdn/shop/files/zws-abbreviation-logo-black.png?v=1738558649&width=150"]').attr('alt', 'Zero Waste Store logo ');

$('img[src="data:image/svg+xml,%3Csvg%20viewBox%3D%220%200%20200%20200%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3C%2Fsvg%3E"]').attr('alt', 'Vetted products icon');

$('img[src="data:image/svg+xml,%3Csvg%20viewBox%3D%220%200%20200%20200%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3C%2Fsvg%3E"]').last().attr('alt', 'Plastic free packaging icon');

$('img[src="data:image/svg+xml,%3Csvg%20viewBox%3D%220%200%20300%20300%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3C%2Fsvg%3E"]').first().attr('alt', '1% for the Planet icon');

$('img[src="data:image/svg+xml,%3Csvg%20viewBox%3D%220%200%20300%20300%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3C%2Fsvg%3E"]').last().attr('alt', 'Star icon');

$('img[src="data:image/svg+xml,%3Csvg%20viewBox%3D%220%200%20200%20200%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3C%2Fsvg%3E"]').last().attr('alt', 'ZWS reward system icon');
$("h3>em:empty").append('<span style="display:none">.</span>')

$('img[src="/cdn/shop/t/71/assets/pf-52134b4c--sarah_1200x.jpg?v=1626276692"]').attr("alt", "Sarah sitting on grass, posing and smiling");

$('img[src="https://cdn.shopify.com/s/files/1/2806/9936/t/71/assets/pf-38fb2c1b--jj_1200x.jpg?v=1626124118"]').attr("alt", "JJ sitting on a boat and smiling");

$('img[src="https://cdn.shopify.com/s/files/1/2806/9936/t/71/assets/pf-4b4cadf0--zwsfounders_1200x.jpg?v=1626277663"]').attr("alt", "ZWS founders Sarah and JJ on a bicycle");

$('img[src="https://cdn.shopify.com/s/files/1/2806/9936/t/71/assets/zwsessentials_640x640-1656010513831_1200x.jpg?v=1656010528"]').attr("alt", "ZWS essentials product image");
$('img[src="/cdn/shop/t/71/assets/pf-b7c5ad1e--zwsteamsarah_1200x.jpg?v=1626280048"]').attr("alt", "Sarah smiling and posing for a picture");

$('img[src="https://cdn.shopify.com/s/files/1/2806/9936/t/71/assets/pf-85535c48--zwsteamjj_1200x.jpg?v=1626377905"]').attr("alt", "Gerard smiling and posing for a picture");

$('img[src="https://cdn.shopify.com/s/files/1/2806/9936/t/71/assets/pf-2d215a41--zwsteammonica_1200x.jpg?v=1632255074"]').attr("alt", "Monica smiling and posing for a picture");

$('img[src="https://cdn.shopify.com/s/files/1/2806/9936/files/kristen_1200x.png?v=1722622553"]').attr("alt", "Kristen sitting on a wooden log and posing for a picture");

$('img[src="https://cdn.shopify.com/s/files/1/2806/9936/files/Jenn_1200x.png?v=1723139789"]').attr("alt", "Jen sitting in a car and posing for a picture");

$('img[src="https://cdn.shopify.com/s/files/1/2806/9936/files/picture_of_me_1200x.jpg?v=1723139905"]').attr("alt", "Heather smiling and posing for a picture");

$('img[src="https://cdn.shopify.com/s/files/1/2806/9936/files/clara_ca5f6000-183a-4bb7-a9c6-2140baff9762_1200x.png?v=1722628835"]').attr("alt", "Clara smiling and posing for a picture");

$('img[src="https://cdn.shopify.com/s/files/1/2806/9936/files/clara_ca5f6000-183a-4bb7-a9c6-2140baff9762_1200x.png?v=1722628835"]').attr("alt", "Esther smiling and posing for a picture");

$('img[src="https://cdn.shopify.com/s/files/1/2806/9936/files/jaz_1200x.png?v=1722626458"]').attr("alt", "Jaz with her black cat smiling and posing for a picture");

$('img[src="https://cdn.shopify.com/s/files/1/2806/9936/files/freda_1200x.png?v=1723140228"]').attr("alt", "Freda smiling and posing for a picture");

$('img[src="https://cdn.shopify.com/s/files/1/2806/9936/t/71/assets/pf-c5ad1eda--zwsteamdaniel_1200x.jpg?v=1632260995"]').attr("alt", "Daniel smiling and posing for a picture");

$('img[src="https://cdn.shopify.com/s/files/1/2806/9936/t/71/assets/pf-4c7baeeb--zwsteammascots_1200x.png?v=1632255483"]').attr("alt", "Jax and Kane");
$('img[src="https://cdn.shopify.com/s/files/1/2806/9936/t/71/assets/esther_selfie--edited-1674148917740_1200x.jpg?v=1674148927"]').attr('alt', 'Esther smiling and posing for a picture');
$('a[href="https://www.biologicaldiversity.org/"]').attr('aria-label', 'Center for Biological Diversity website');
$('.sustainability-icon-element').each(function() {
  var altText = $(this).find('.name').text().trim();
  $(this).find('img').attr('alt', altText);
});
$('input#filter_icons').attr('aria-label', 'Search filter icons');
$('img[src="https://cdn.shopify.com/s/files/1/2806/9936/t/71/assets/zwsiconrewardssustainableadvocatewhite-1676058259621_56x.png?v=1676058260"]').attr('alt', 'Plant icon');

$('img[src="https://cdn.shopify.com/s/files/1/2806/9936/t/71/assets/zwsiconrewardsearthloverwhite-1676058421753_56x.png?v=1676058423"]').attr('alt', 'Heart icon');

$('img[src="https://cdn.shopify.com/s/files/1/2806/9936/t/71/assets/zwsiconrewardsecowarriorwhite-1676058480441_56x.png?v=1676058481"]').attr('alt', 'Warrior icon');
$('img[src="https://cdn.shopify.com/s/files/1/2806/9936/t/71/assets/pf-244c1b69--Asset-3_1200x.png?v=1612465847"]').attr('alt', 'Landfill waste');

$('img[src="https://cdn.shopify.com/s/files/1/2806/9936/t/71/assets/pf-69ccf445--Asset-4_1200x.png?v=1612466093"]').attr('alt', 'Fuel icon');

$('img[src="https://cdn.shopify.com/s/files/1/2806/9936/t/71/assets/pf-4c1b69cc--iconco2_1200x.png?v=1612465854"]').attr('alt', 'CO2 icon');

$('img[src="https://cdn.shopify.com/s/files/1/2806/9936/t/71/assets/pf-5ea72b31--Photo-Sep-08-9-43-53-PM_1200x.jpg?v=1615350934"]').attr('alt', 'Flowers');

$('img[src="https://cdn.shopify.com/s/files/1/2806/9936/t/71/assets/pf-7374d6ef--Unpaper-Towels_1200x.jpg?v=1615351166"]').attr('alt', 'Wheat plant');

$('img[src="https://cdn.shopify.com/s/files/1/2806/9936/t/71/assets/pf-a72b31b6--Togo-Ware-Bamboo-Utensils_1200x.jpg?v=1615350961"]').attr('alt', 'Wooden spoons');
$('img[src="https://cdn.shopify.com/s/files/1/2806/9936/t/71/assets/iconcarbon-1636659952537_1200x.png?v=1636659956"]').attr('alt', 'Green leaf icon');

$('img[src="https://cdn.shopify.com/s/files/1/2806/9936/t/71/assets/iconpackaging-1636659974801_1200x.png?v=1636659979"]').attr('alt', 'Packaging icon');

$('img[src="https://cdn.shopify.com/s/files/1/2806/9936/t/71/assets/iconmail-1636659963337_1200x.png?v=1636659967"]').attr('alt', 'Mail icon');

$('img[src="https://cdn.shopify.com/s/files/1/2806/9936/t/71/assets/pf-5bf0f60f--recycledcardboardboxwhite_1200x.png?v=1607367641"]').attr('alt', 'Recycled cardboard box');

$('img[src="https://cdn.shopify.com/s/files/1/2806/9936/t/71/assets/pf-705bf0f6--wateractivatedtapewhite_1200x.png?v=1607367527"]').attr('alt', 'Water-activated tape');

$('img[src="https://cdn.shopify.com/s/files/1/2806/9936/t/71/assets/pf-afdf705b--cornstarchpackingpeanutswhite_1200x.png?v=1607367520"]').attr('alt', 'Cornstarch packing peanuts');

$('img[src="https://cdn.shopify.com/s/files/1/2806/9936/t/71/assets/pf-f0f60fca--recycledkraftpaperandpackagingwhite_1200x.png?v=1607367645"]').attr('alt', 'Recycled kraft paper and packaging');

$('img[src="https://cdn.shopify.com/s/files/1/2806/9936/t/71/assets/pf-df705bf0--inklessshippinglabelwhite_1200x.png?v=1607367524"]').attr('alt', 'Inkless shipping label');



  let Intervaltime_task1;
let counter_task1 = 0; 


try {
    Intervaltime_task1 = setInterval(GenerateAriaLabelFortask1, 500);
}
catch (err) {
  
}


function GenerateAriaLabelFortask1() {
   
   counter_task1++;
$('img[src="https://www.gravatar.com/avatar/d41d8cd98f00b204e9800998ecf8427e"]').attr('alt', 'User avatar');
   $('img[data-srcset^="//zerowastestore.com/cdn/shop/files/1ftp_BusinessMember_Horizontal_Black.png"]').attr('alt', '1FTP Business Member Horizontal Black');
$('img[data-srcset^="//zerowastestore.com/cdn/shop/files/ClimateNeutralCertified_Label_Horizontal_Black.jpg"]').attr('alt', 'Climate Neutral Certified Label Horizontal Black');
$('img[data-srcset^="//zerowastestore.com/cdn/shop/files/Rainforest_Trust-Conservation_Circle-Seal"]').attr('alt', 'Rainforest Trust Conservation Circle Seal');
$('img[data-srcset^="//zerowastestore.com/cdn/shop/files/Untitled_design_1_0078fd53-d069-460d-ace7-bb9f825c8ae3.png"]').attr('alt', 'Proud Supporter Conservation Florida');

   
    if (  $("button.t4s-minicart-tabs-item").length) {

 $("button.t4s-minicart-tabs-item").attr("aria-label", "minicart item");
$('img[src="https://www.gravatar.com/avatar/d41d8cd98f00b204e9800998ecf8427e"]').attr('alt', 'User avatar');
   $('img[data-srcset^="//zerowastestore.com/cdn/shop/files/1ftp_BusinessMember_Horizontal_Black.png"]').attr('alt', '1FTP Business Member Horizontal Black');
$('img[data-srcset^="//zerowastestore.com/cdn/shop/files/ClimateNeutralCertified_Label_Horizontal_Black.jpg"]').attr('alt', 'Climate Neutral Certified Label Horizontal Black');
$('img[data-srcset^="//zerowastestore.com/cdn/shop/files/Rainforest_Trust-Conservation_Circle-Seal"]').attr('alt', 'Rainforest Trust Conservation Circle Seal');
$('img[data-srcset^="//zerowastestore.com/cdn/shop/files/Untitled_design_1_0078fd53-d069-460d-ace7-bb9f825c8ae3.png"]').attr('alt', 'Proud Supporter Conservation Florida');
        clearInterval(Intervaltime_task1);
       
    }
    
  
    if (counter_task1 >= 20) {
        clearInterval(Intervaltime_task1);
       
    }
}



console.log("ready1");
});
